<h3 mat-dialog-title class="title">
    {{ 'users.edit.stores.manageStores' | translate }}
</h3>

<mat-dialog-content>
    <div class="loading-container" *ngIf="isLoading">
      <txp-loading [color]="loadingColor.COLOR"></txp-loading>
    </div>
    
    <div class="table-content">
        <table mat-table
               [dataSource]="dataSource"
               matSort
               matSortActive="number"
               matSortDirection="asc"
               matSortDisableClear>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                 [checked]="selection.hasValue() && isAllSelected()"
                                 [indeterminate]="selection.hasValue() && !isAllSelected()"
                                 data-qa-label="MasterToggleCheckBox">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                                  (change)="$event ? selection.toggle(row) : null"
                                  [checked]="selection.isSelected(row)"
                                  data-qa-label="MenuRowCheckBox">
                    </mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="number">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'users.edit.stores.storeNumber' | translate }} </th>
                <td mat-cell *matCellDef="let store">
                {{ store.number }}
                </td>
            </ng-container>
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.edit.stores.storeName' | translate }} </th>
                <td mat-cell *matCellDef="let store">
                {{ store.name }}
                </td>
            </ng-container>
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.edit.stores.address' | translate }} </th>
                <td mat-cell *matCellDef="let store">
                {{ store.address }}
                </td>
            </ng-container>
            <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'users.edit.stores.city' | translate }} </th>
                <td mat-cell *matCellDef="let store">
                {{ store.city }}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
        </table>
    </div>
</mat-dialog-content>

<mat-dialog-actions *ngIf="!isLoading">
    <txp-button
        [style]="buttonStyle.SECONDARY"
        [disabled]="isSaving"
        data-qa-label="CancelButton"
        (click)="onCancel()">
        {{ 'form.button.cancel' | translate }}
    </txp-button>
    <txp-button
        [style]="buttonStyle.PRIMARY"
        [loading]="isSaving"
        data-qa-label="SaveButton"
        (click)="onAdd()">
        {{ 'form.button.add' | translate }}
    </txp-button>
</mat-dialog-actions>
